import { Observable, ReplaySubject, Subject } from 'rxjs';
import { Error } from '@supoui/shared/components/error-message/error-message.component';
import { tap } from 'rxjs/operators';

export class StateService<T> {
  protected state: Subject<T | Error> = new ReplaySubject<T | Error>(1);
  constructor() {}

  public sendError(err: any): void {
    this.state.next(new Error(err));
  }

  public reset(): void {
    const oldState = this.state;
    this.state = new ReplaySubject<T | Error>(1);
    oldState.complete();
  }

  protected sendModel(obj: T): void {
    this.state.next(obj);
  }

  protected getModel(): Observable<T> {
    return this.state.asObservable().pipe(
      tap((response: any) => {
        if (response instanceof Error) {
          throw response;
        }
      })
    );
  }
}
